module.exports = __webpack_public_path__ + "static/img/GoodpregnancyImgdetail6.5ef0afc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/project/integralMallProject/images/GoodpregnancyImgdetail6.jpg
// module id = /fyK
// module chunks = 6